import styled from "styled-components";
import { CloseLinear } from "../Iconsax/CloseLinear.js";
import { ITheme } from "../Theme/Theme.types.js";

const getShapeMap = ({ theme }: { theme: ITheme }): Record<"square" | "round", string> => ({
    square: theme.radius.s,
    round: theme.radius.l,
});

export const PopoverBodyContainer = styled.div<{ shape: "square" | "round"; removePadding?: boolean }>`
    background-color: ${({ theme }) => theme.grayscale.white};
    border-radius: ${({ shape, theme }) => getShapeMap({ theme })[shape]};
    box-shadow: ${({ theme }) => theme.shadows.popover};
    padding: ${(props) => (props.removePadding ? `${props.theme.spacing[8]} 0` : `${props.theme.spacing[16]}`)};
`;

export const PopoverCloseIcon = styled(CloseLinear)`
    position: absolute;
    top: ${({ theme }) => theme.rem(0.875)};
    right: ${({ theme }) => theme.rem(0.875)};
    cursor: pointer;
    padding: ${({ theme }) => theme.spacing[8]};
    color: ${({ theme }) => theme.grayscale[80]};
    transition: all 200ms;
    border-radius: ${({ theme }) => theme.radius.round};

    &:hover {
        color: ${({ theme }) => theme.grayscale[100]};
        background-color: ${({ theme }) => theme.grayscale[50]};
    }
`;
